export const TabsAccordion = (function ($) {
    const breakpoint = 640;

    let $controls;
    let $contents;
    let isMobile = null;
    let tabs = [];
    let mastheadHeight = 0;

    function getEffectiveBackgroundColor(el) {
        while (el && el !== document.documentElement) {
            const bg = window.getComputedStyle(el).backgroundColor;
            if (bg && bg !== 'transparent' && !bg.includes('rgba(0, 0, 0, 0)')) {
                return bg;
            }
            el = el.parentElement;
        }

        return window.getComputedStyle(document.documentElement).backgroundColor;
    }

    const cache = () => {
        tabs = [];

        $controls.find('li').each(function () {

            const key = $(this).find('[data-tabs-label]').attr('data-tabs-label');
            const $panel = $contents.filter(`[data-tabs-content="${key}"]`);

            if (!$panel.length) return;

            tabs.push({
                key, // used by [data-tabs-label] and [data-tabs-content]
                $tab: $(this), // li element
                $panel, // associated [data-tabs-content]
                parent: $panel.parent(),
                index: $panel.index()
            });
        });
    };

    const applyLayout = () => {
        const nowMobile = window.innerWidth < breakpoint;
        if (nowMobile === isMobile) return;

        isMobile = nowMobile;

        if (isMobile) {
            tabs.forEach(t => {
                t.$tab.after(t.$panel);
                t.$panel.hide();
            });
        } else {
            // set background color based on parent background
            const color = getEffectiveBackgroundColor(document.querySelector('[data-tabs-control]'));
            $controls.css('background', color);

            // restore original DOM order
            tabs.forEach(t => {
                if (t.index === 0) {
                    t.parent.prepend(t.$panel);
                } else {
                    t.parent.children().eq(t.index - 1).after(t.$panel);
                }
            });
        }

        $controls.find('li button').removeAttr('data-tabs-active')
            .end() // go back to $controls
            .find('li:first-child button').attr('data-tabs-active', '');

        $contents.hide().first().show();
    };

    const openTab = (e) => {
        const $trigger = $(e.currentTarget);
        const key = $trigger.attr('data-tabs-label');
        const isActive = $trigger.is('[data-tabs-active]');
        const $panel = $contents.filter(`[data-tabs-content="${key}"]`);

        if (!$panel.length) return;

        if (isActive && isMobile) {
            $trigger.removeAttr('data-tabs-active');
            $panel.hide();
        } else {
            // hide all other tabs, both on accordion and tabs display
            $controls.find('li button').removeAttr('data-tabs-active');
            $trigger.attr('data-tabs-active', '');

            $contents.hide();
            $panel.show();
            window.scrollTo(0, $contents.parent().offset().top - mastheadHeight);
        }
    };

    const bindEvents = () => {
        let raf;

        window.addEventListener('resize', () => {
            cancelAnimationFrame(raf);
            raf = requestAnimationFrame(applyLayout);
        });

        window.addEventListener('header:layout-change', () => setTimeout(setTopPosition, 500));

        $controls.on('click', 'li [data-tabs-label]', openTab);
    };

    const setTopPosition = () => {
        mastheadHeight = document.querySelector('#masthead').getBoundingClientRect().bottom;
        $controls.css('top', `${mastheadHeight}px`);
    }

    return {
        init() {
            $controls = $('[data-tabs-control]');
            $contents = $('[data-tabs-content]');

            if (!$controls.length || !$contents.length) return;

            cache();
            applyLayout();
            setTopPosition();
            bindEvents();
        }
    };

})(jQuery);